import styled, { css } from 'react-emotion';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import CloudUpload from '@material-ui/icons/CloudUpload';
import BaseCircularProgress from '@material-ui/core/CircularProgress';

import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

export const Content = styled(ListItemIcon)`
  display: flex;
  align-items: center;
  margin-right: 0;
  cursor: ${(props) => (props.uploadEnable ? 'pointer' : 'auto')};
`;

export const inputBoxCss = css`
  width: 0;
  height: 0;
  position: absolute;
  marginleft: -90px;
`;

export const UploadIcon = styled(CloudUpload)`
  font-size: 20px;
  border-radius: 4px;
  color: ${colors.grayLight1};
  background-color: ${colors.beige};
  padding: 9px;
`;

export const LoaderContainer = styled('div')`
  border-radius: 4px;
  background-color: ${colors.beige};
  padding: 9px;
`;

export const CircularProgress = styled(BaseCircularProgress)`
  color: ${colors.grayDark};
`;
